// eslint-disable-next-line import/no-anonymous-default-export
export default {
    menu: {
        dashboard: {
            name: 'Home'
        },
        policies : {
            name: 'Policies'
        },
        'damage-reports' : {
            name : 'Claims'
        },
        'claims-managers' : {
            name : 'Claims managers'
        },
        'vat-rates': {
            name: 'VAT Rates'
        }
    }
}